import styled from 'styled-components';
import { Label } from 'reactstrap';

export default styled(Label)`
  font-weight: normal;
`;
